import React, { Component } from "react";
import { useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
  Toast,
} from "react-bootstrap-v5";
import { toast } from "react-toastify";
import Select from "react-select";

import PickUpServices from "../../../Services/PickUpService";
import masterServices from "../../../Services/masterService";
import { vendorService } from "../../../Services/vendorService";
import * as JobOptions from "../../../Function/defaultJobOptions";
import csc from "country-state-city";

const shipmentCategory = [
  { value: "Commercial", label: "Commercial" },
  { value: "Personal ( New)", label: "Personal ( New)" },
  { value: "Relocation", label: "Relocation" },
  { value: "Mix ( Relocation & New)", label: "Mix ( Relocation & New)" },
];

class EditPickUp extends Component {
  state = {
    pickup: [],
    itemData: {
      pickup_country: "",
    },
    wareHouseData: [],
    vendorData: [],
    countryData: {
      countryCode: "",
      states: [],
      cities: [],
    },
    country: csc.getAllCountries(),
  };

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const pid = query.get("id");

    // Fetching pick up information
    PickUpServices.getPickUpDetails({ pickup_id: pid }).then((result) => {
      if (result.status === true) {
        this.setState({ itemData: result.data });
        this.getStateCity(result?.data?.pickup_country, result?.data?.pickup_state);
      }
    });

    // Fetching warehouse list
    masterServices.get_warehouse().then((result) => {
      if (result.status === true) {
        let wOpt = result.data.map((item) => {
          return { value: item._id, label: item.name };
        });

        this.setState({ wareHouseData: wOpt });
      }
    });

    // Fetching vendor list
    let param = { search1: "Transport" };
    vendorService.getVendor(param).then((result) => {
      if (result.status === true) {
        let vOpt = result.data.map((item) => {
          return { value: item._id, label: item.vendor_name };
        });
        this.setState({ vendorData: vOpt });
      }
    });
  }

  getStateCity = async (country, state, city) => {
    let data = this.state.countryData;
    let findIso = this?.state?.country?.find(
      (item) => item.name === country
    )?.isoCode;
    data.countryCode = findIso;
    let states = await csc.getStatesOfCountry(findIso);
    data.states = states;
    let findState = states.find((item) => item.name === state)?.isoCode;
    let cities = csc.getCitiesOfState(findIso, findState);
    data.cities = cities;
    this.setState({ countryData: data });
  };

  handleChangeValue = (event, objInnerKey = "") => {
    let formData = this.state.itemData;
    let fieldKey = objInnerKey !== "" ? objInnerKey : event.target.name;
    let fieldValue =
      event.value === undefined ? event.target.value : event.value;

    formData[fieldKey] = fieldValue;
    if(fieldValue==="WORLDTODOOR"){
      delete formData.vendor_id
    }
    this.setState({ itemData: formData });
  };

  handleSubmit = () => {
    let postData = this.state.itemData;
    postData["pickup_id"] = postData._id;
    // console.log(postData, "postData");
    PickUpServices.setPickUpDetails(postData).then((res) => {
      if (res.status === true) {
        toast.success(res.message);
        this.props.history.push("/pick-up-list");
      }
    });
  };

  onCountryChange = (e, name) => {
    let data = this.state.countryData;
    let itemData = this.state.itemData;
    let states, countryCode;
    if (name === "pickup_country") {
      let findIso = this.state.country.find(
        (item) => item.name === e.target.value
      ).isoCode;
      data.states = csc.getStatesOfCountry(findIso);
      data.countryCode = findIso;
    } else if (name === "pickup_state") {
      let findIso = this.state.countryData.states.find(
        (item) => item.name === e.target.value
      ).isoCode;

      data.cities = csc.getCitiesOfState(data.countryCode, findIso);
    }
    itemData[name] = e.target.value;
    // console.log("countryDatacountryDatacountryDatacountryData", states);
    // console.log(data, "ddddddddddddd");
    this.setState({ countryData: data, itemData: itemData });
  };

  render() {
    const { itemData, wareHouseData, vendorData } = this.state;
    if (Object.keys(itemData).length === 0) return false;


    // console.log(this.state.countryData)

    return (
      <Card>
        <Card.Body>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Customer Name</Form.Label>
                <Form.Control
                  name="full_name"
                  value={itemData.full_name}
                  readOnly
                  onChange={(e) => this.handleChangeValue(e)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Job No</Form.Label>
                <Form.Control
                  name="job_no"
                  value={itemData.job_token}
                  readOnly
                  onChange={(e) => this.handleChangeValue(e)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Retailer No</Form.Label>
                                <Form.Control
                                    name="retailer_phone_number"
                                    value={itemData.retailer_phone_number}
                                    onChange={(e) => this.handleChangeValue(e)}
                                />
                            </Form.Group>

                        </Col> */}
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Retailer Mobile No</Form.Label>
                <Form.Control
                  name="retailer_phone_number"
                  value={itemData.retailer_phone_number}
                  onChange={(e) => this.handleChangeValue(e)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Pick up status</Form.Label>
                {/* <Form.Control
                                    name="job_no"
                                    value={itemData.job_token}
                                    readOnly
                                    onChange={(e) => this.handleChangeValue(e)}
                                /> */}
                <Select
                  options={JobOptions.statusOption()}
                  name="pickup_status"
                  value={JobOptions.statusOption().filter(
                    (obj) => obj.value === itemData.pickup_status
                  )}
                  onChange={(e) => this.handleChangeValue(e, "pickup_status")}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Who will pick up</Form.Label>
                <Select
                  options={JobOptions.pickUpOption()}
                  name="pickup_type"
                  value={JobOptions.pickUpOption().filter(
                    (obj) => obj.value === itemData.pickup_type
                  )}
                  onChange={(e) => this.handleChangeValue(e, "pickup_type")}
                />
              </Form.Group>
            </Col>

            <Col>
              <div className="position-relative me-2">
                <label className="form-label">Transport By</label>
                <div key={`inline-radio`} className="mb-3">
                  <Form.Check
                    className="mt-1"
                    inline
                    label="W2D Transport"
                    name="transport_by"
                    value="WORLDTODOOR"
                    type="radio"
                    id={`inline-radio-1`}
                    checked={this.state.itemData.transport_by === 'WORLDTODOOR'}
                    onChange={(e) =>
                      this.handleChangeValue(e, "transport_by")
                    }
                  />
                  <Form.Check
                    className="mt-1"
                    inline
                    label="Transport Vendor"
                    name="transport_by"
                    value="VENDOR"
                    type="radio"
                    id={`inline-radio-2`}
                    checked={this.state.itemData.transport_by === 'VENDOR'}
                    onChange={(e) =>
                      this.handleChangeValue(e, "transport_by")
                    }
                  />
                </div>
              </div>
            </Col>

            {this.state.itemData.transport_by ===
              "VENDOR" && (
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Transport Vendor Name</Form.Label>
                  <Select
                    name="vendor_id"
                    options={vendorData}
                    value={vendorData.filter(
                      (obj) => obj.value === itemData.vendor_id
                    )}
                    onChange={(e) => this.handleChangeValue(e, "vendor_id")}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  name="pickup_address"
                  value={itemData.pickup_address}
                  onChange={(e) => this.handleChangeValue(e)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Local Delivery Warehouse</Form.Label>
                <Select
                  name="ware_houses"
                  options={wareHouseData}
                  value={wareHouseData.filter(
                    (obj) => obj.value === itemData.ware_houses
                  )}
                  onChange={(e) => this.handleChangeValue(e, "ware_houses")}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Pick Up Date</Form.Label>
                <Form.Control
                  name="pickup_date"
                  type="date"
                  value={itemData.pickup_date}
                  onChange={(e) => this.handleChangeValue(e)}
                />
              </Form.Group>
            </Col>

            <Col>
              {/* <label className="form-label">Time</label> */}
              <Form.Label>Time</Form.Label>
              <Form.Control
                type="time"
                // className="form-control"
                name="pickup_time"
                value={itemData.pickup_time}
                onChange={(e) => this.handleChangeValue(e)}
              />
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Postal Code</Form.Label>
                <Form.Control
                  name="pickup_postal_code"
                  value={itemData.pickup_postal_code}
                  onChange={(e) => this.handleChangeValue(e)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Shipment Description</Form.Label>
                <Form.Control
                  name="what_to_pickup"
                  value={itemData.what_to_pickup}
                  onChange={(e) => this.handleChangeValue(e)}
                />

                {
                  // formValidator.message('what_to_pickup', item.what_to_pickup, 'required', { className: 'text-danger' })
                }
              </Form.Group>
            </Col>
            <Col>
              {" "}
              <Form.Group className="mb-3">
                <Form.Label>Receipt/Invoice Ref#</Form.Label>
                <Form.Control
                  name="invoice_id"
                  value={itemData.invoice_id}
                  onChange={(e) => this.handleChangeValue(e)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Pick Up Country</Form.Label>
                <Form.Select
                  name="pickup_country"
                  value={itemData?.pickup_country}
                  onChange={(e) => this.onCountryChange(e, "pickup_country")}
                >
                  <option value="">Select Country</option>
                  {this.state.country.map((item1) => {
                    return (
                      <option key={item1.name} value={item1.name}>
                        {item1.name}
                      </option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Pick Up State</Form.Label>
                <Form.Select
                  name="pickup_state"
                  value={itemData?.pickup_state}
                  onChange={(e) => this.onCountryChange(e, "pickup_state")}
                >
                  <option value="">Select State</option>
                  {this.state.countryData.states.length > 0 &&
                    this.state.countryData?.states &&
                    this.state.countryData.states.map((item1) => {
                      return (
                        <option key={item1.name} value={item1.name}>
                          {item1.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Pick Up City</Form.Label>
                <Form.Select
                  name="pickup_city"
                  value={itemData?.pickup_city}
                  onChange={(e) => this.onCountryChange(e, "pickup_city")}
                >
                  <option value="">Select City</option>
                  {this.state.countryData.cities.length > 0 &&
                    this.state.countryData?.cities &&
                    this.state.countryData.cities.map((item1) => {
                      return (
                        <option key={item1.name} value={item1.name}>
                          {item1.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Col>
            <Form.Group className="mb-3">
              <Form.Label>Comments</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="comment"
                value={itemData.comment}
                onChange={(e) => this.handleChangeValue(e)}
              />
            </Form.Group>
          </Col>

          <Row>
            <Col>
              <Button variant="primary" onClick={() => this.handleSubmit()}>
                Save Changes
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { EditPickUp };
